module.exports = __webpack_public_path__ + "static/img/frown.69396fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/frown.png
// module id = ACsn
// module chunks = 1